// extracted by mini-css-extract-plugin
export default {"confirm":"deleteConfirm_confirm__Uam5Z","body":"deleteConfirm_body__JajQi"};